import React from 'react';
import PropType from 'prop-types';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import themeColors from '../../assets/styles/themeColors';
import { ReactComponent as RightArrow } from '../../assets/images/svg/right-arrow.svg';
import Anchor from '../../components/Anchor/Anchor';
import { RegisterButton } from '../../components/Registration/RegistrationPageOne';

export const PopupContainer = styled.div`
  display: ${({ isOpen }) => (isOpen ? 'flex' : 'none')};
  position: fixed;
  z-index: 1;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: ${themeColors.colorWhite};
  justify-content: center;
  align-items: flex-end;
  transform: ${({ isOpen }) => (isOpen ? 'translateY(0)' : 'translateY(100%)')};
  transition: transform 0.3s ease-out;
`;

export const PopupContent = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 2rem;
`;

const Go = styled(RightArrow)`
  display: flex;
  height: 15px;
  width: 18px;
  align-items: center;
  margin-left: 10px;
`;

const SkipForNowLink = styled.span`
  display: flex;
  justify-content: center;
  margin-top: 2rem;
  text-decoration: underline;
  color: ${themeColors.colorPrimary};
  font-size: 16px;
  margin-left: 8px;
  cursor: pointer;
`;

const RegistrationPopup = ({ isOpen, setIsOpen }) => {
  const { t } = useTranslation();
  const closePopup = () => setIsOpen(false);
  return isOpen ? (
    <PopupContainer isOpen={isOpen}>
      <PopupContent isOpen={isOpen}>
        <RegisterButton onClick={closePopup}>
          {t('quickRegistration.twoStep.leftPane.popupButtonText')}
          <Go />
        </RegisterButton>
        <SkipForNowLink>
          <Anchor
            sameWindow
            type="website"
            value="https://goldsilver.com"
            text={t('common.skipForNow')}
            bold
          />
        </SkipForNowLink>
      </PopupContent>
    </PopupContainer>
  ) : null;
};

RegistrationPopup.propTypes = {
  isOpen: PropType.bool,
  setIsOpen: PropType.func,
};

export default RegistrationPopup;
